import { FooterSchema } from './Footer.styles';

export const footerStyles: FooterSchema = {
  footer: {
    bg: 'transparent',
    bgSize: 'cover',
    bgPos: 'bottom',
    pt: '0',
  },
  stackGap: '1',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    pr: '0',
    mb: ['3', '8'],
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
  },
  footerLink: {
    color: 'beta.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  footerLinkTel: {
    color: 'beta.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  customFooterLink: {
    color: 'beta.500',
    textTransform: 'capitalize',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontSize: 'sm',
    fontWeight: 'medium',
    pos: 'relative',
    bottom: 'px',
    h: 'auto',
  },
  footerLinks: {
    mt: '3',
    ml: ['unset', null, 'auto'],
    pb: ['4', null, '0'],
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'white',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'inline-flex',
  },
  footerContentContainer: {
    px: ['2.5', 'unset'],
    gap: ['2', '6'],
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: 'column',
      },
    },
    mb: '0',
  },
  nav: {
    fontSize: 'sm',
    fontWeight: 'medium',
    minW: [null, null, '370px'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '28',
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
      ". ."
    `,
    sx: {
      '> a': {
        h: 'unset',
        color: 'delta.800',
      },
      button: {
        h: 'unset',
        '.chakra-text': {
          color: 'delta.800',
          fontWeight: 'medium',
        },
      },
    },
  },
  LinkText: {
    fontWeight: 'medium',
  },
  blurb: {
    flex: 'unset',
    textAlign: ['center', 'left'],
    color: 'delta.800',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '4'],
  },
  blurbHeading: {
    ml: 'unset',
    mt: ['2', 'unset'],
    color: 'gray.400',
  },
  blurbHeadingAge: {
    borderColor: 'delta.800',
    border: '4px',
    mb: '2',
    boxSize: '8',
    fontSize: 'xs',
    color: 'delta.800',
    lineHeight: 'normal',
  },
  blurbHeadingThink: {
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '3',
    color: 'delta.800',
  },
  blurbContent: {
    color: 'delta.800',
    ml: 'unset',
    mr: [null, null, 'auto'],
  },
  copyright: {
    color: 'delta.800',
    textAlign: ['center', 'left'],
    mt: ['7'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: ['semibold', 'medium'],
  },
  container: {
    sx: {
      '&&': {
        p: '0',
        px: '0',
      },
    },
    mt: '3',
  },
  emailUs: {
    fontSize: 'md',
    fontWeight: 'bold',
    color: 'delta.800',
  },
  footerDownloadImage: {
    border: '2px',
    borderColor: 'white',
    borderRadius: 'md',
    filter: 'drop-shadow(0px 2px 7px rgba(0, 0, 0, 0.3))',
  },
  partnerWrapper: {
    mr: 'unset',
  },
  quickLinks: {
    color: ['beta.500', 'delta.800'],
    textTransform: ['uppercase', 'none'],
    textAlign: ['center', 'left'],
    fontSize: ['xs', 'md'],
    fontWeight: 'semibold',
  },
  ourPartners: {
    fontSize: ['xs', 'md'],
    color: ['beta.500', 'delta.800'],
    textTransform: ['uppercase', 'none'],
    fontWeight: 'semibold',
  },
  weAccept: {
    fontSize: ['xs', 'md'],
    color: ['beta.500', 'delta.800'],
    textTransform: ['uppercase', 'none'],
    fontWeight: 'semibold',
  },
  weAcceptBox: {
    mb: ['0', '2'],
  },
};
